<template>
	<section class="mall-image-data">
		<div class="breadcrumb_content">
			<div class="Bread_crumbs flex-align-items p-15">
				{{ $t('PDS.CurrentPosition') }}
				<div>
					<span style="cursor: pointer" @click="routeFunc('home')">{{ $t('PDS.HomePage') }} / </span>
					<span style="cursor: pointer" @click="routeFunc('/PDSINDEX')">{{ $t('PDS.PDSDataSet') }} / </span>
					<span>{{ $t('PDS.Moon') }}</span>
				</div>
			</div>
		</div>
		<div class="mallBody">
			<div class="malltab">
				<div class="malltab_item" :class="datacheck == i ? 'check_item' : ''" v-for="(item, i) in dataList" :key="i" @click="mallclick(i)">
					{{ language == 'en' ? item.enName : item.name }}
				</div>
			</div>
			<div class="dirFrame" v-if="dataList.length > 0">
				<!-- 检索功能 -->
				<div class="search_body">
					<div class="search_title">
						<div class="line"></div>
						{{ $t('PDS.Payload') }}
					</div>

					<div class="search_cont">
						<!-- <div class="search_item">全部</div> -->
						<div class="search_item" :class="YXZHcheck == i ? 'search_itemCheck' : ''" @click="checkYXZH(i)" v-for="(item, i) in dataList[datacheck].children" :key="i">
							{{ language == 'en' ? item.enName : item.name }}
						</div>
					</div>

					<div class="search_title" style="margin-top: 20px" v-if="dataList[datacheck].children && dataList[datacheck].children[YXZHcheck].children.length > 0">
						<div class="line"></div>
						{{ $t('PDS.DataLevel') }}
					</div>
					<div class="search_cont" v-if="dataList[datacheck].children">
						<!-- <div class="search_item">全部</div> -->
						<div class="search_item" :class="SJJBcheck == i ? 'search_itemCheck' : ''" @click="checkSJJB(i)" v-for="(item, i) in dataList[datacheck].children[YXZHcheck].children" :key="i">
							{{ language == 'en' ? item.enName : item.name }}
						</div>
					</div>
					<div class="search_cont2" style="display: flex; margin-top: 20px">
						<div style="line-height: 38px; margin: 0 10px">
							{{ $t('PDS.CollectionStartTime')
							}}<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="searchJ.startTime" type="datetime" :placeholder="$t('PDS.CollectionStartTime')" @change="changeStart">
							</el-date-picker>
						</div>
						<div style="line-height: 38px; margin: 0 10px">
							{{ $t('PDS.CollectionEndTime')
							}}<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="searchJ.endTime" type="datetime" :placeholder="$t('PDS.CollectionEndTime')" @change="changeEnd">
							</el-date-picker>
						</div>
						<div style="margin-left: 15px">
							<el-button type="primary" @click="getSearchList()">{{ $t('PDS.Search') }}</el-button>
							<!-- <el-button type="info">重置</el-button> -->
						</div>
					</div>
				</div>

				<div class="SJbody" v-loading="loading" element-loading-text="加载中">
					<div class="table_topdiv" style="justify-content: center; background-color: #fff" v-if="searchList.length == 0"><el-empty description="暂无数据" /></div>
					<div v-else v-for="(item, i) in searchList" :key="i" class="dataItem">
						<div class="item_img">
							<img class="item_img" v-if="item.image" :src="imgServeUrl + item.image" alt="" />
							<img class="item_img" v-else :src="defualtImg" alt="" />
						</div>
						<div class="item_label">
							<div class="item_title">
								<div class="_title">{{ item.name }}</div>
							</div>
							<div class="line"></div>

							<div class="item_Cz">
								<div class="item_CzSl">
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('PDS.VolumeDataStartTime') }}</div>
										<div class="CzSl_listtext">{{ item.startTime }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('PDS.VolumeDataEndTime') }}</div>
										<div class="CzSl_listtext">{{ item.endTime }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('PDS.DetectionTask') }}</div>
										<div class="CzSl_listtext">{{ item.detectionTask }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('PDS.Payload') }}</div>
										<div class="CzSl_listtext">{{ item.loadName }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('PDS.DataLevel') }}</div>
										<div class="CzSl_listtext">{{ item.dataLevelName }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('PDS.DataSize') }}</div>
										<div class="CzSl_listtext">{{ item.dataSize }}</div>
									</div>

									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('PDS.FileTotal') }}</div>
										<div class="CzSl_listtext">{{ item.dataTotal }}</div>
									</div>
								</div>
								<div>
									<div class="item_CzBtn1" @click="getAnnexZip(item)">{{ $t('PDS.DownloadNow') }}</div>
									<!-- <div class="item_CzBtn2" @click="dataSearch(item)">加入收藏夹</div> -->
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pagediv" v-if="searchList.length > 0">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						:page-sizes="[10, 20, 30, 50]"
						:page-size="100"
						layout="total, sizes, prev, pager, next, jumper"
						:total="listTotal"
					>
					</el-pagination>
					<!-- <el-button size="mini" @click="goPage()">Go</el-button> -->
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'PDS',
	components: {},
	data() {
		return {
			language: localStorage.getItem('change-language'),
			loading: false,
			currentPage: 1,
			listTotal: 0,
			pageSize: 1, //页
			pageNum: 10, //条
			searchJ: {
				startTime: '',
				endTime: ''
			},
			imgServeUrl: window.dataManage.imgDev,
			defualtImg: require('./../../assets/mars.png'),
			dataList: [
				{
					name: '天问一号'
				}
			],
			datacheck: 0,

			catalogueList: [],
			dataTaskDesc: [],
			dataExplain: [],
			dataQuteThank: [],
			copyright: [],
			searchShow: false,
			SJJBcheck: 0,
			YXZHcheck: 0,
			searchList: []
		}
	},
	mounted() {
		this.getdata()
	},
	computed: {},
	methods: {
		changeStart(val) {
			this.searchJ.startTime = val
			console.log(val)
		},
		changeEnd(val) {
			this.searchJ.endTime = val
		},
		async getAnnexZip(obj) {
			// const userToken = cookie.get('PIE_MALL_Token')
			// if (!userToken) {
			// 	this.$message.warning('请登录用户！')
			// 	return
			// }
			let res = await this.$http.get(this.$const.Platformconsulting.psdAnnexZipUrl + obj.pdsDatasetId)
			this.$message.success('下载成功！')
			if (res.code === 200) {
				window.open(this.$const.Platformconsulting.getPdsAnnexZipURl + `?fileName=${res.data}&delete=false`, '_blank')
				// let res1 = await this.$http.download(this.$const.Platformconsulting.getPdsAnnexZipURl, { fileName: res.data, delete: false })
				// let res1 = await this.$http.download(this.$const.Platformconsulting.downloadURl, { fileName: res.data, delete: true })
			}
		},
		handleSizeChange(val) {
			this.pageNum = val
			this.getdata()
		},
		handleCurrentChange(val) {
			this.goPageNum = val
			this.getdata()
		},
		goPage() {
			this.pageSize = this.goPageNum
			this.getdata()
		},
		formatBytes(bytes, decimals = 2) {
			if (bytes === 0) return '0 Bytes'
			const k = 1024
			const dm = decimals < 0 ? 0 : decimals
			const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
			const i = Math.floor(Math.log(bytes) / Math.log(k))
			return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
		},
		routeFunc(name) {
			if (name == 'home') {
				location.href = location.host // 重新加载当前页面
				location.replace(window.location.origin)
			} else {
				location.reload() // 重新加载当前页面
				location.reload(true) // 强制从服务器重新加载当前页面
			}
		},
		async getdata(item) {
			let res = await this.$http.get(this.$const.Platformconsulting.scienceCategoryURl)
			if (res.code === 200) {
				res.data.map((item) => {
					if (item.name == '月球') {
						this.dataList = item.children
					}
				})
				this.getSearchList()
			}
		},

		// 检索数据

		async getSearchList(item) {
			this.loading = true
			console.log(this.dataList[this.datacheck].children[this.YXZHcheck].children)
			var parms = {
				pageNum: this.pageSize,
				pageSize: this.pageNum,
				// ...this.searchJ,
				startTime: '2007-01-01',
				endTime: this.searchJ.endTime,
				category: this.dataList[this.datacheck].parentId, // 火星 id
				task: this.dataList[this.datacheck].id, //任务id 天问一号

				// dataCatalogueId: item || '', //数据任务目录id

				load: this.dataList[this.datacheck].children[this.YXZHcheck].id, //载荷 id
				dataLevel: this.dataList[this.datacheck].children[this.YXZHcheck].children.length > 0 ? this.dataList[this.datacheck].children[this.YXZHcheck].children[this.SJJBcheck].id : '' //数据级别 id
			}
			try {
				let res = await this.$http.get(this.$const.Platformconsulting.pdsDatasetURL, parms)
				if (res.code === 200) {
					this.loading = false
					this.searchList = res.rows
					this.listTotal = res.total
				}
			} catch (e) {
				console.log(e)
			}
		},

		checkSJJB(i) {
			this.SJJBcheck = i
			this.getSearchList()
		},
		checkYXZH(i) {
			this.YXZHcheck = i
			this.SJJBcheck = 0
			this.getSearchList()
		},

		mallclick(i) {
			this.datacheck = i
			this.getSearchList()
		}
	}
}
</script>

<style lang="scss" scoped>
.mall-image-data {
	width: 100%;
	.bannerBG {
		width: 100%;
		height: 250px;
		background-image: url('../../assets/imgs/PDS/bg.png');
		background-repeat: no-repeat;
		background-size: cover;
	}
	.breadcrumb_content {
		width: 80%;
		margin: 0 auto;
	}
	// .bannerTitle {
	// 	width: 80%;
	// 	margin: 0 auto;
	// 	padding-top: 3%;
	// 	line-height: 60px;
	// 	font-size: 28px;
	// 	color: #f5f5f5;
	// }
	.bannerzn {
		width: 80%;
		margin: 0 auto;
		line-height: 40px;
		font-size: 22px;
		color: #f5f5f5;
	}
	.mallBody {
		width: 80%;
		margin: 0 auto;
		color: #f5f5f5;
		background: #f0f5ff;
		height: 80vh;

		.malltab {
			// margin-top: 30px;
			display: flex;
			height: 60px;
			background: #ffffff;
			box-shadow: -2px 7px 15px 0px #d2e0f7;
			border-top: 1px solid;
			border-bottom: 1px solid;

			border-image: radial-gradient(208% 143% at 50% 0%, rgba(21, 65, 140, 0.3) 0%, rgba(21, 65, 140, 0) 100%);

			position: relative;
			.renBtn {
				position: absolute;
				top: 0;
				right: 15px;
				color: #888;
				line-height: 60px;
				font-size: 15px;
				cursor: pointer;
			}
			.malltab_item {
				width: 171px;
				height: 59px;
				background: #fff;
				text-align: center;
				line-height: 59px;
				font-size: 18px;
				color: #000;
				cursor: pointer;
			}
			.check_item {
				color: #15418c;
				font-size: 20px;
				font-weight: 700;
				background: radial-gradient(208% 143% at 50% 0%, rgba(21, 65, 140, 0.3) 0%, rgba(21, 65, 140, 0) 100%);
			}
		}
		.mallfilke {
			margin-top: 50px;
			height: 60px;
			position: relative;
			.mallfilke_line {
				position: absolute;
				top: 25px;
				left: 0;
				height: 1px;
				width: 100%;
				background: radial-gradient(208% 143% at 50% 0%, rgba(21, 65, 140, 0.3) 0%, rgba(21, 65, 140, 0) 100%);
				// background: red;
			}
			.mallfilke_tab {
				margin: 0 10%;
				display: flex;
				height: 50px;
				line-height: 50px;
				.mallfilke_tabItem {
					cursor: pointer;
					width: 150px;
					line-height: 50px;
					background: #ffffff;
					border-radius: 30px;
					border: 1px solid #15418c;
					text-align: center;
					margin: 0 50px;
					font-family: MicrosoftYaHeiUI;
					font-size: 18px;
					color: #15418c;
					font-style: normal;
					z-index: 99;
				}
				.mallfilke_tabItemCheck {
					background: #15418c;
					color: #fff;
				}
			}
		}
		.dirFrame {
			margin-top: 40px;
			// height: 50vh;
			width: 100%;
			// background: red;
			color: #000;
			.dataMl {
			}
			.dataOrder {
				background: #ffffff;
				border-radius: 4px;
				border: 1px solid rgba(21, 65, 140, 0.2);
				min-height: 40vh;
				padding: 50px;
				.dotMsg {
					height: 50px;
					line-height: 50px;
					font-size: 22px;
					font-weight: 700;
					color: #000;
					padding-top: 80px;
					padding-left: 30px;
				}
			}
			.search_body {
				//  min-height: 371px;
				background: #ffffff;
				border-radius: 4px;
				border: 1px solid rgba(21, 65, 140, 0.2);
				padding: 15px;

				.search_title {
					font-family: MicrosoftYaHeiUISemibold;
					font-size: 16px;
					color: #000000;
					font-weight: 700;
					display: flex;
					line-height: 16px;
					height: 30px;
					.line {
						width: 3px;
						margin-right: 5px;
						height: 14px;
						background: #15418c;
					}
				}
				.search_cont {
					display: flex;
					flex-wrap: wrap;
					.search_item {
						min-width: 160px;
						height: 36px;
						line-height: 36px;
						text-align: center;
						cursor: pointer;
						// background: #15418C;
						background: radial-gradient(208% 143% at 50% 0%, rgba(21, 65, 140, 0.3) 0%, rgba(21, 65, 140, 0) 100%);
						color: #15418c;
						border-radius: 4px;
						margin-right: 15px;
						padding: 0 15px;
						margin-bottom: 10px;
					}
					.search_itemCheck {
						background: #15418c;
						color: #fff;
					}
				}
			}
		}
	}
}
.SJbody {
	margin-top: 25px;
}
.dataItem {
	display: flex;
	height: 200px;
	margin-bottom: 15px;
	.item_img {
		width: 294px;
		height: 196px;
		background: #000;
	}
	.item_label {
		flex: 1;
		margin-left: 15px;
	}
	.item_title {
		display: flex;
		._title {
			font-family: MicrosoftYaHeiUISemibold;
			font-size: 22px;
			color: #000000;
			text-align: left;
			height: 40px;
			width: 70%;
			font-weight: 700;
		}
		._btn {
			display: flex;
			flex: 1;
			justify-content: flex-end;
			.btnlist {
				background: #daa77f7b;
				margin-right: 15px;
				border-radius: 2px;
				font-family: MicrosoftYaHeiUISemibold;
				font-size: 14px;
				color: #15418c;
				height: 30px;
				line-height: 30px;
				text-align: center;
				font-style: normal;
				padding: 0px 8px;
			}
		}
	}
	.line {
		width: 100%;
		height: 1px;
		border: 1px solid #15418c;
		opacity: 0.2;
		margin-bottom: 10px;
	}
	.item_desc {
		font-family: MicrosoftYaHeiUI;
		font-size: 16px;
		color: #333333;
		line-height: 25px;
		text-align: left;
		font-style: normal;
	}
	.item_Cz {
		display: flex;
		padding: 15px 0;
		.item_CzSl {
			flex: 1;
			display: flex;
			flex-wrap: wrap;

			// flex-direction: column;

			.CzSl_row {
				display: flex;
				width: 1000px;
			}

			.CzSl_list {
				display: flex;
				width: 330px;
				align-items: baseline;
				.CzSl_listLabel {
					// width: 126px;
					height: 30px;

					font-family: MicrosoftYaHeiUI;
					font-size: 14px;
					color: #666666;
					text-align: left;
					font-style: normal;
				}

				.CzSl_listtext {
					font-family: MicrosoftYaHeiUI;
					font-size: 14px;
					// margin-left: 10px;
					color: #15418c;
					text-align: left;
					font-style: normal;
				}
			}
		}
		.item_CzBtn {
			width: 88px;
			height: 67px;
			// background-image: url('../../assets/imgs/RemoteSensingMall/card1.png');
			background-repeat: no-repeat;
			background-size: cover;
			text-align: center;
			line-height: 67px;
			color: #fff;
			cursor: pointer;

			background: #15418c;
		}
		.item_CzBtn1 {
			margin-right: 15px;
			width: 88px;
			height: 40px;
			// background-image: url('../../assets/imgs/RemoteSensingMall/card1.png');
			background-repeat: no-repeat;
			// background-size: cover;
			background-size: 100% 100%;

			text-align: center;
			line-height: 40px;
			color: #fff;
			cursor: pointer;
			font-size: 14px;
			margin-bottom: 15px;

			background: #15418c;
		}
		.item_CzBtn2 {
			margin-right: 15px;
			width: 88px;
			height: 40px;
			background-image: url('../../assets/imgs/RemoteSensingMall/card2.png');
			background-repeat: no-repeat;
			background-size: 100% 100%;
			text-align: center;
			line-height: 40px;
			color: #15418c;
			cursor: pointer;
			font-size: 14px;
			margin-bottom: 15px;
		}
	}
}
.pagediv {
	display: flex;
	justify-content: flex-end;
}
</style>